import { apiFetch, apiPost, apiPut, apiDelete } from '@/lib/api-client';

export async function getPeople() {
  try {
    return await apiFetch<any[]>('/api/people');
  } catch {
    return [];
  }
}

export async function getPersonById(id: string) {
  try {
    return await apiFetch<any>(`/api/people/${id}`);
  } catch {
    return null;
  }
}

export async function getPersonBySlug(slug: string) {
  try {
    return await apiFetch<any>(`/api/public/people/slug/${encodeURIComponent(slug)}`);
  } catch {
    return null;
  }
}

export async function createPerson(data: any) {
  return apiPost('/api/people', data);
}

export async function updatePerson(id: string, data: any) {
  return apiPut(`/api/people/${id}`, data);
}

export async function deletePerson(id: string) {
  return apiDelete(`/api/people/${id}`);
}
